<template lang="html">
  <div class="home-container">
    <!--<public-header v-bind:openLoginDialog="openLoginDialog"></public-header>-->
    <div class="wrapper">
    	<div class="banner">
    		<div class="bd">
    			<ul>
            <transition name="banner">
      				<li class="banner1" v-if="banner === 0">
      					<!-- <div class="banner2dp"></div> -->
      					<div class="banner2icon1"></div>
      					<div class="banner2icon2"></div>
      					<div class="banner2icon3"></div>
      					<div class="txt">
      						<p class="txt1"></p>
      						<p class="txt2"></p>
      					</div>
      				</li>
            </transition>
            <transition name="banner">
      				<li class="banner2" v-if="banner === 1">
      					<div class="meteor">
      						<div class="star star1"></div>
      						<div class="star star2"></div>
      						<div class="star star3"></div>
      						<div class="star star4"></div>
      					</div>
      					<div class="img">
      						<!-- <div class="banner1map"></div>
      						<div class="banner1map1"></div>
      						<div class="banner1map2"></div>
      						<div class="banner1left"></div>
      						<div class="banner1right"></div> -->
									<img class="banner2-img-left" src="../../static/home/images/banner/float-left.png">
									<img class="banner2-img-right" src="../../static/home/images/banner/float-right.png">
      					</div>
      					<div class="txt">
      						<p class="txt1">千万用户 · 百万资源</p>
      						<p class="txt2">成为互联网+教育的领航人</p>
      						<p class="not-animated"><a href="javascript:;">马上加入</a></p>
      					</div>
      				</li>
            </transition>
    			</ul>
    		</div>
    		<div class="hd"><ul></ul><a href="javascript:;" class="prev"><i class="icon icon-other-bannerleft" @click="changeBar()"></i></a><a href="javascript:;" class="next"><i class="icon icon-other-bannerright" @click="changeBar()"></i></a></div>
    	</div>
    	<div class="common-box setion3">
    		<div class="commonwidth clearfix">
    			<div class="module-title">我们可以提供</div>
    			<div class="module-intro">We can provide</div>
    			<div class="m-provide-list clearfix">
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-2.png" alt=""></div>
    					<div class="txt">
    						<h2>用户</h2>
    						<p>超过8000万教师、学生、家长已经成为畅言教育用户</p>
    					</div>
    				</div>
    				</a>
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-4.png" alt=""></div>
    					<div class="txt">
    						<h2>资源</h2>
    						<p>与39家出版社合作，覆盖全国90%的区域，正版资源量近百万</p>
    					</div>
    				</div>
    				</a>
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-5.png" alt=""></div>
    					<div class="txt">
    						<h2>数据</h2>
    						<p>汇聚教学环节数万级别的数据，支持数据的全平台共享，小应用也能玩大数据</p>
    					</div>
    				</div>
    				</a>
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-1.png" alt=""></div>
    					<div class="txt">
    						<h2>渠道</h2>
    						<p>应用正式发布可直达 15省18 市上万所学校，广渠道推送，多平台分发</p>
    					</div>
    				</div>
    				</a>
    			</div>
					<div class="m-provide-list clearfix">
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-9.png" alt=""></div>
    					<div class="txt">
    						<h2>文件存储服务</h2>
    						<p>多种存储方案适配不同项目规模；断点续传和秒传，完善文件上传体验</p>
    					</div>
    				</div>
    				</a>
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-10.png" alt=""></div>
    					<div class="txt">
    						<h2>音频检索服务</h2>
								<p>依托讯飞强大的语音识别和转写技术，实现关键词和知识点的快速高效检索</p>
    					</div>
    				</div>
    				</a>
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-11.png" alt=""></div>
    					<div class="txt">
    						<h2>媒体转换服务</h2>
								<p>20多种主流媒体格式转换；根据业务需要，实现在线动态扩容，提升转换吞吐量</p>
    					</div>
    				</div>
    				</a>
    				<a href="javascript:;" class="display-block">
    				<div class="m-provide-item hasintro">
    					<div class="img"><img src="../../static/home/images/open-12.png" alt=""></div>
    					<div class="txt">
    						<h2>内容安全监管服务</h2>
								<p>快速检测海量信息中的敏感内容，并进行标记和拦截处理。净化环境，护航K12教育</p>
    					</div>
    				</div>
    				</a>
    			</div>
    		</div>
    	</div>
    	<div class="common-box setion6">
    		<div class="commonwidth clearfix">
    			<div class="module-title">我们承诺</div>
    			<div class="module-intro">We are committed to</div>
    			<div class="m-committed-list">
    				<div class="m-committed-item">
    					<h2>标准接口</h2>
    					<p>健全的接口调用指南，可直接全文检索</p>
    				</div>
    				<span class="separate"></span>
    				<div class="m-committed-item">
    					<h2>接入简单</h2>
    					<p>24 小 时 完 成 应 用 接 入</p>
    				</div>
    				<span class="separate"></span>
    				<div class="m-committed-item">
    					<h2>多级服务</h2>
    					<p>常见问题、及时反馈、在线客服、<br>开发者论坛，为您保驾护航</p>
    				</div>
    			</div>
    		</div>
    	</div>
    	<div class="common-box setion7">
    		<div class="commonwidth clearfix">
    			<div class="module-title">支持多终端，应用接入四步法</div>
    			<div class="module-intro">Support multiple terminal</div>
    			<div class="m-support-list clearfix">
    				<div class="parallaxbg"></div>
    				<div class="m-support-item">
    					<div class="iconbox">
    						<img src="../../static/home/images/support-1.png">
    					</div>
    					<div class="txt">
    						<h2>注册开发者账号</h2>
    						<p>注册账号，提交认证材料，成为平台认可的开发者</p>
    					</div>
    					<div class="btnbox">
                <a @click="goPersonalHome(1)" style="cursor: pointer">进入 ➠</a>
    					</div>
    				</div>

    				<div class="m-support-item">
    					<div class="iconbox">
    						<img src="../../static/home/images/support-2.png">
    					</div>
    					<div class="txt">
    						<h2>创建应用</h2>
    						<p>使用账号登录，进入个人中心，创建自己的应用，获取相应的APPkey</p>
    					</div>
    					<div class="btnbox">
    						<a @click="goPersonalHome" style="cursor: pointer">进入 ➠</a>
    					</div>
    				</div>

    				<div class="m-support-item">
    					<div class="iconbox">
    						<img src="../../static/home/images/support-3.png">
    					</div>
    					<div class="txt">
    						<h2>接入openAPI</h2>
    						<p>参考开发文档，在平台上获取接入帮助，快速完成开发</p>
    					</div>
    					<div class="btnbox">
    						<a @click="goPersonalHome" style="cursor: pointer">进入 ➠</a>
    					</div>
    				</div>

    				<div class="m-support-item">
    					<div class="iconbox">
    						<img src="../../static/home/images/support-3.png">
    					</div>
    					<div class="txt">
    						<h2>调试并发布</h2>
    						<p>提供完备的调试工具和沙箱环境，顺利完成应用发布</p>
    					</div>
    					<div class="btnbox">
    						<a @click="goPersonalHome" style="cursor: pointer">进入 ➠</a>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    	<div class="common-box setion8">
    		<div class="commonwidth clearfix">
    			<div class="module-title">合作伙伴</div>
    			<div class="module-intro">Our Partners</div>
    			<div class="m-partners-list">
    				<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo1.png">
						</div>
						<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo2.png">
						</div>
						<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo3.png">
						</div>
						<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo4.png">
						</div>
    			</div>
					<div class="m-partners-list">
    				<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo5.png">
						</div>
						<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo6.png">
						</div>
						<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo7.png">
						</div>
						<div class="m-partners-item">
							<img src="../../static/home/images/partner/logo8.png">
						</div>
    			</div>
    		</div>
    	</div>
			<div class="join-us">
				<el-button type="primary" class="join-button" @click="joinUs">立即入驻</el-button>
			</div>
    	<div class="footer">
				<div class="footer-desc">
					<div class="footer-decs-items">
						<h3>常用入口</h3>
						<ul>
							<li class="footer-decs-li"><a href="#/baseDocument" target="_blank">基础文档</a></li>
							<li class="footer-decs-li"><a href="#/ssoDocument" target="_blank">服务能力</a></li>
							<li class="footer-decs-li"><a href="#/standardDocument" target="_blank">平台规范</a></li>
						</ul>
					</div>
					<div class="footer-decs-items">
						<h3>其它产品</h3>
						<ul>
							<li class="footer-decs-li"><a href="http://www.zhixue.com" target="_blank">智学网</a></li>
							<li class="footer-decs-li"><a href="http://www.jyyun.com" target="_blank">讯飞教育云</a></li>
							<li class="footer-decs-li"><a href="http://www.yixuexiao.cn" target="_blank">智慧课堂</a></li>
						</ul>
					</div>
					<div class="footer-decs-items">
						<h3>联系我们</h3>
						<ul>
							<li class="footer-decs-li"><img class="icon"  src="../../static/home/images/phone.png">4000-199-199（周一至周五9:00-17:00）</li>
							<li class="footer-decs-li"><img class="icon" src="../../static/home/images/qq.png">4008878557</li>
							<li class="footer-decs-li"><img class="icon" src="../../static/home/images/email.png">jyyun_open@iflytek.com</li>
						</ul>
					</div>
					<div class="footer-decs-items">
						<h3>关于我们</h3>
						<div>
							<img src="../../static/home/images/qrcode.png">
						</div>
					</div>
				</div>
    		<div class="copyright">
			    <div>版权所有 科大讯飞股份有限公司技术支持</div>
				<div>
					<span>京ICP备13025521号-14</span>
                    <img src="../assets/images/u3.png">
					<span>京公网安备 11010802029435号</span>
				</div>
			</div>
    	</div>
    </div>
    <!--返回顶部-->
    <div class="fixed-sidebar">
    	<a class="backtop" href="javascript:;" title="返回顶部"><i class="icon icon-other-gotop"></i></a>
    	<!-- <a class="feedback" href="javascript:;" title="快速反馈"><i class="icon icon-other-feedback"></i></a> -->
    </div>
  </div>
</template>

<script>
  import publicHeader from '@/components/public-header/public-header.vue'
  import util from '@/common/js/util'
  import store from '@/store/index'
  import {checkLogin} from '@/api/login-api'
// import '@/assets/js/animate.min.js'
// import '@/assets/js/home.js'
// import '@/assets/js/common.js'
export default {
  components: {
    publicHeader
  },
  data () {
    return {
      banner: 0,
      timer: null,
      hasLogin:false,
      openLoginDialog:false,
      user:{}
    }
  },
  created (){
  },
  mounted () {
    this.$nextTick(function () {
      this.showHome()
    })
    let that = this
    this.timer = setInterval(function () {
      that.changeBar()
    }, 5000)
  },
  beforeDestroy() {
    if (this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer); //关闭
    }
  },
  methods: {
    showHome () { // 引入的之前用jquery切好的页面...
    	//合作伙伴动效
    	$(".m-partners-item").each(function(){
    		var _this = $(this);
    		_this.hover(function(){
    			_this.children(".img").animate({opacity:0,top:-141},300);
    			_this.children(".txt").animate({opacity:100,top:0},300);
    		},function(){
    			_this.children(".img").animate({opacity:100,top:0},300);
    			_this.children(".txt").animate({opacity:0,top:141},300);
    		});
    	});
    	//当滚动条的位置处于距顶部100像素以下时，跳转链接出现，否则消失
    	$(window).scroll(function(){
    		if ($(window).scrollTop()>100){
    			$(".backtop").fadeIn(500).css("display","block");
    		}
    		else
    		{
    			$(".backtop").fadeOut(500);
    		}
    	});
    	//当点击跳转链接后，回到页面顶部位置
    	$(".backtop").click(function(){
    		//$('body,html').animate({scrollTop:0},1000);
    		if ($('html').scrollTop()) {
    			$('html').animate({ scrollTop: 0 }, 1000);
    			return false;
    		}
    		$('body').animate({ scrollTop: 0 }, 1000);
    		return false;
    	});
    },
    changeBar () {
      this.banner = 1 - this.banner
    },
    //进入创建应用
    goCreateApp(){
      store.commit('changeLoginDialog',{
        isShow:false
      });
      this.hasLogin = util.localstorage.get("hasLogin")==null?this.hasLogin: util.localstorage.get("hasLogin");
      if(this.hasLogin){
        this.user = util.localstorage.get("user")==null?this.user: JSON.parse(util.localstorage.get("user"));
        if(this.user.status==2){
            this.$router.push({
              path:'/appCreate'
            })
        }else if(this.user.status==1){
          this.$message.error({message: '请耐心等待认证审核！', duration: 1000});
          return;
        }else {
          this.$confirm('创建应用需要完成开发者认证，是否前往认证？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.replace({name: 'register',query: {step: 2}});
          }).catch(() => {
            return;
          });
        }
      }else{
        store.commit('changeLoginDialog',{
          isShow:true
        });
      }
    },
    //进入个人中心（index为1时，代表注册）
    goPersonalHome(index){
      this.hasLogin = util.localstorage.get("hasLogin")==null?this.hasLogin: util.localstorage.get("hasLogin");
      if(this.hasLogin){
        this.$router.push({
          path:'/personalHome'
        })
      }else{
        if(index ==1){
          this.$router.push({
            path:'/register'
          })
        }else {
          store.commit('changeLoginDialog',{
            isShow:true
          });
        }
      }
    },
		joinUs () {
			this.goPersonalHome(1)
		}
  }
}
</script>

<style lang="less">
.home-container {
  background-color: #fff;
}
.banner {
  &-enter-active, &-leave-active {
    opacity: 1;
    transition: all 0.05s ease-in-out;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
}
.join-us {
	width: 100%;
	height: 78px;
	background: #2d365d;
	text-align: center;
}
.join-us .join-button {
	padding: 15px 57px;
	font-size: 18px;
	margin-top: 14px;
	border-radius: 2px;
}
.footer {
	background: #283053;
	color: #e5e5e5;
	a {
		color: #e5e5e5;
		&:hover {
			color: #e5e5e5;
		}
		&:focus {
			outline: none;
		}
	}
	h3 {
		font-size: 20px;
		margin-bottom: 30px;
	}
}
.footer-desc {
	width: 1140px;
	margin: 0 auto;
	padding: 40px 0 20px 0;
	overflow: hidden;
}
.footer-decs-items {
	float: left;
	margin: 0 60px;
}
.footer-decs-li {
	font-size: 14px;
	margin-bottom: 10px;
	line-height: 21px;
	.icon {
		vertical-align: top;
		margin-right: 10px;
		width: 21px;
		height: 21px;
	}
}
.copyright {
	// height: 64px;
	border-top: 1px solid #1a1f3c;
	font-size: 14px;
	text-align: center;
	padding: 15px 0 10px;
	line-height: 30px;
	font-family: 'FZLTHJW', arial,'Microsoft YaHei',SimSun,sans-serif,tahoma;
	img{
		width: 20px;
		height: 20px;
		vertical-align: text-bottom;
	}
}
.banner2-img-left {
	position: absolute;
	right: 50%;
	top: 50%;
	margin-right: 160px;
	margin-top: -40px;
}
.banner2-img-right {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -10px;
	margin-left: 166px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue